import styles from "./LTwoColsRight.module.css";

/**
 * LTwoColsRight — page layout 2-kolumnowy: główny obszar + prawy sidebar.
 *
 * Lustrzany odpowiednik LTwoColsLeft. Right sidebar często mieści okna typu
 * social-icons, newsletter, related-posts.
 */
export function LTwoColsRight({ main, rightSidebar }: LTwoColsRightProps) {
  return (
    <div className={styles.root}>
      <div className={styles.main}>{main}</div>
      <aside className={styles.sidebar}>{rightSidebar}</aside>
    </div>
  );
}

export type LTwoColsRightProps = {
  main: React.ReactNode;
  rightSidebar: React.ReactNode;
};
